import api from '@/services/api';
export default {
    async importEmployees({dispatch, commit}, importData) {
        const {data} = await api.post('/api/employee/import-employees', importData);
        if (data.success) {
            dispatch('getEmployees');
        }
        return data;
    },
    async addEmployee({dispatch, commit}, userData) {
        const {data} = await api.post('/api/employee/add-employee', userData);
        console.log(data)
        if (data.success) {
            dispatch('getEmployees');
        }
        return data;
    },
    async exportEmployees({dispatch, commit}, params) {
        const data = await api.get(`/api/employee/export-employees`, {params, responseType: 'blob'}).then(response => {
            let headers = response.headers;
            const url = window.URL.createObjectURL(new Blob([response.data],{type:headers['content-type']}));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Report.xlsx');
            document.body.appendChild(link);
            link.click();
        });
    },
    async getEmployees({dispatch, commit}, params) {
        params = params ? params : { page: 1, limit: 10 };
        const {data} = await api.get('/api/employee/get-employees', {params});
        if (data.success) {
            commit('SET_NUMBER_OF_RESULTS', data.numberOfResults);
            commit('SET_EMPLOYEES', data.data);
        }
        return data;
    },
    async getClassList({ dispatch, commit }, params) {
        const { data } = await api.get('/api/employee/get-class-list', { params });
        if (data.success) {
            commit('SET_CLASSES', [{name: 'all', _id: null}, ...data.data.list]);
        }
        return data;
    },
    async getDepartmentList({ dispatch, commit }, params) {
        const { data } = await api.get('/api/employee/get-department-list', { params });
        if (data.success) {
            commit('SET_DEPARTMENTS', [{ name: 'All', _id: null }, ...data.data.list]);
        }
        return data;
    },
    async getEmployeeDetail({dispatch, commit}, params) {
        return new Promise((resolve, reject) => {
            api.get('/api/employee/get-employee-detail', {params}).then(({data}) => {
                if (data.success) {
                    resolve(data);
                } else {
                    console.log(data);
                    reject(data);
                }
            }).catch(error => {
                console.warn(error)
                reject();
            });
        })
    },
    async getEmployeeNormalCourses({dispatch, commit}, params) {
        return new Promise((resolve, reject) => {
            api.get('/api/userProcess/getEmloyeeCourses', {params}).then(({data}) => {
                if (data.success) {
                    resolve(data);
                } else {
                    reject(data);
                }
            }).catch(error => {
                console.warn(error)
                reject();
            });
        })
    },
    async getEmployeeNativeCourses({dispatch, commit}, params) {
        return new Promise((resolve, reject) => {
            api.get('/api/userProcess/getEmployeeNativeCourses', {params}).then(({data}) => {
                if (data.success) {
                    resolve(data);
                } else {
                    reject(data);
                }
            }).catch(error => {
                console.warn(error)
                reject();
            });
        })
    },
    async updateEmployeeMail({dispatch, commit}, updateData) {
        const {data} = await api.put('/api/employee/update-employee-mail', updateData);
        return data;
    },
    async getCourses({ dispatch, commit }, params) {
        let response = await api.get('/api/courses', { params }).catch(error => {
            console.warn(error)
        });
        let courses = response.data.data.list;
        commit('SET_COURSES', courses);

    },
}